import React from 'react';
import { ModalContextCreator } from '../../actions/ContextCreators';

const ModalReducer = (state, action) => {
    switch (action.type) {
        case 'SESSION_TIMER_MODAL':
            return {
                ...state,
                sessionTimerModal: action.sessionTimerModal,
            };
        case 'MODAL_FAILURE':
            return {
                ...state,
                modalTarget: action.name,
                Error: action.error,
            };
        default:
            throw new Error();
    }
};

export default function ModalProvider({ children }) {
    const [state, dispatch] = React.useReducer(ModalReducer, {
        sessionTimerModal: true,
        closePage: false
    });

    return (
        <ModalContextCreator.Provider value={{ state, dispatch }}>
            {children}
        </ModalContextCreator.Provider>
    );
}
